import React from 'react';
import { Link } from 'react-router-dom';

const CustomLink = React.forwardRef((props, ref) => <Link ref={ref} {...props} />);
export default CustomLink;
